import AddressModel from './address.model'
import BaseModel from './base.model';

export default class DeliveryModel extends BaseModel {

  is_required = false;
  price = 80;
  address = new AddressModel();
  instructions = null;
  
  constructor (data) {
    super();
    if(this.isEmpty(data)) return this;
    this.is_required = data.is_required || false;
    this.price = data.price || 80;
    this.address = new AddressModel(data.address);
    this.instructions = data.instructions;
  }
}
